import axios from 'axios'
import { apiObject } from './apiobject'

const userform = {
  ...apiObject,
  url: '/bulkops/forms/'
}

const contact = {
  ...apiObject,
  url: '/bulkops/contacts/'
}

const cases = {
  ...apiObject,
  url: '/bulkops/cases/'
}

const contact_import = {
  ...apiObject,
  url: '/bulkops/contacts/import/',
  downloadFile (obj) {
    return axios.get(`${this.url}${obj}/download/`, {
      responseType: 'arraybuffer'
    })
  }
}

const case_import = {
  ...apiObject,
  url: '/bulkops/cases/import/',
  downloadFile (obj) {
    return axios.get(`${this.url}${obj}/download/`, {
      responseType: 'arraybuffer'
    })
  }
}

const userform_import = {
  ...apiObject,
  url: '/bulkops/forms/import/',
  downloadFile (obj) {
    return axios.get(`${this.url}${obj}/download/`, {
      responseType: 'arraybuffer'
    })
  }
}

const form_import = {
  ...apiObject,
  url: '/bulkops/forms/populate/',
  downloadFile (obj) {
    return axios.get(`${this.url}${obj}/download/`, {
      responseType: 'arraybuffer'
    })
  }
}

export default {
  userform,
  contact,
  case_import,
  contact_import,
  userform_import,
  form_import,
  cases
}
